module.exports = __webpack_public_path__ + "files/aa22ff6fd92ecdf402f09a8180354751.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600.woff2
// module id = 1354
// module chunks = 59